import React, { useEffect, type ReactNode } from 'react';
import resetStyles from '@atlaskit/css-reset';
import { setGlobalTheme } from '@atlaskit/tokens/set-global-theme';
import { defaultTheme } from './configs/theme';

type ADSGlobalStylesProps = {
	children: ReactNode;

	/**
	 * Are these styles for the fallback (static) app?
	 *
	 * @default false
	 */
	isStatic?: boolean;
};

/**
 * Component for setting up ADS theme styles in the client.
 *
 * If the app is rendered inside the SSR shell, some of these styles are already included.
 * For static apps, these styles need to be added on the client side.
 */
export function ADSGlobalStyles({ children, isStatic }: ADSGlobalStylesProps): React.JSX.Element {
	useEffect(() => {
		setGlobalTheme(defaultTheme);
	}, []);

	useEffect(() => {
		if (isStatic) {
			// Inject static fallback app reset styles into the <head />.
			const styleElement = document.createElement('style');
			styleElement.id = 'ads-reset-styles';
			styleElement.textContent = resetStyles;
			document.head.appendChild(styleElement);

			return () => {
				document.head.removeChild(styleElement);
			};
		}
	}, [isStatic]);

	return <>{children}</>;
}
